import type { Dispatch, SetStateAction } from "react";

export const ShowClosedFilter = ({
	showClosed,
	setShowClosed,
}: {
	showClosed: boolean;
	setShowClosed: Dispatch<SetStateAction<boolean>>;
}) => {
	return (
		<div className="checkbox-wrapper">
			<label htmlFor={"show-closed"}>Show Closed</label>
			<input
				id={"show-closed"}
				type={"checkbox"}
				className={"checkbox"}
				checked={showClosed}
				onChange={() => {
					setShowClosed((prev) => {
						return !prev;
					});
				}}
			/>
			{/** biome-ignore lint/a11y/noLabelWithoutControl: This is a required label for the class of Toggle */}
			<label htmlFor={"show-closed"} className={"toggle"} />
		</div>
	);
};
